import React, { useState } from "react";
import ProductComponent from "./product.component";
import { Spin } from "antd";

const ProductContainer = () => {
  const [spinning, setSpinning] = useState(false);
  return (
    <div>
      <Spin spinning={spinning}>
        <ProductComponent />
      </Spin>
    </div>
  );
};

export default ProductContainer;
